import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import commissionService from "../api/services/commissionService";
import { handleApiError } from "../utils/apiHelpers";

export const changeCommission = createAsyncThunk(
  "commission/changeCommission",
  async (data, thunkAPI) => {
    try {
      const response = await commissionService.updateCommission(data);
      if (response && response.data) {
        return response.data;
      }
      throw new Error("No data found");
    } catch (error) {
      handleApiError(error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchCommission = createAsyncThunk(
  "commission/fetchCommission",
  async (_, thunkAPI) => {
    try {
      const response = await commissionService.getCommission();
      if (response && response.data) {
        return response.data;
      }
      throw new Error("No data found");
    } catch (error) {
      handleApiError(error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const commissionSlice = createSlice({
  name: "commission",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    updateCommissionData: (state, action) => {
      state.data = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changeCommission.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeCommission.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
      })
      .addCase(changeCommission.rejected, (state, action) => {
        state.error = null;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCommission.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommission.fulfilled, (state, action) => {
        state.data = action.payload;
        state.error = null;
        state.loading = false;
      })
      .addCase(fetchCommission.rejected, (state, action) => {
        state.error = null;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { updateCommissionData, setLoading, setError } =
  commissionSlice.actions;

export default commissionSlice.reducer;
